<mat-toolbar class="bg-roxo">
  <span class="menu-content">
    <span style="margin: 8px;">
      <img src="assets/icons/logo-branco.png"/>
    </span>
  </span>

  <button mat-raised-button (click)="helper.routeToDetalhes()">Hackathon</button>
  <button mat-raised-button *ngIf="avaliacoes" (click)="helper.routeToAvaliacoes()">Avaliação</button>
  <button mat-raised-button *ngIf="equipes" (click)="helper.routeToEquipes()" >Equipe</button>
  <button mat-raised-button *ngIf="mentories && bloquearMentoria()" (click)="helper.routeToMentoria()">Mentoria</button>

  <span *ngIf="loading">
    <mat-progress-spinner
      class="menu-content"
      color="primary"
      mode="indeterminate">
    </mat-progress-spinner>
  </span>

  <span *ngIf="!loading" class="menu-content">
    <span class="menu-botao">
      <img [src]="userProfile.photoURL" [matMenuTriggerFor]="menu">
      <mat-menu #menu="matMenu">
        <p mat-menu-item>{{ userProfile.displayName }}</p>
        <p mat-menu-item (click)="helper.routeToMudarPerfil()">Mudar Perfil</p>
        <p mat-menu-item (click)="signOut()">Sair</p>
      </mat-menu>
    </span>
  </span>
</mat-toolbar>
